import { Injectable } from '@angular/core';

import { Resolve, Router } from '@angular/router';
import { AuthService } from '../_services/auth.service';
import { Globals } from '../_globals';
import { NotificationService } from '../_services/notification.service';


import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/delay';

@Injectable()
export class GroupResolver implements Resolve<any> {

    role = 3;

    constructor(
        public _authService: AuthService,
        public globals: Globals,
        public notificationService: NotificationService,
        private router: Router
    ) { }


    resolve() {
        return new Observable(observer => {

            this._authService.getUser().subscribe((user: any) => {
                this._authService.storeGlobalUserAndOrg(user).subscribe((res: any) => {

                    if (!this.checkRole(res.user.role)) {
                        this.router.navigate(['/restricted']);
                    };

                    return observer.complete();
                });

            });



        });


    }

    public checkRole(role) {

        if (role !== this.role) {
            this.notificationService.notify(
                'danger',
                'Invalid Role',
                'This user does not have correct permissions to view this page',
                'top',
                'right');
            return false;
        } else {
            return true;
        }

    }
}




// WEBPACK FOOTER //
// ./src/app/_resolvers/group.resolver.ts